import React, { useState } from "react";
import useNotifications from "../hooks/useNotifications";
import NotificationDropdown from "./NotificationDropdown";
import NotificationBadge from "./NotificationBadge";
import NotificationIcon from "../components/icons/NotificationIcon";
import { motion, AnimatePresence } from "framer-motion";

export default function NotificationBell() {
  const { count, fetchNotifications, setLoaded, setNotifications, setError, setLoading } = useNotifications();
  const [open, setOpen] = useState(false);

  const handleOpen = async () => {
    setOpen(true);
    setLoading(true);
    setError(null);
    setLoaded(false);
    setNotifications([]);
    // Fetch notifications after opening (dropdown shows skeletons immediately)
    await fetchNotifications();
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className="relative">
      <motion.button
        className="relative flex items-center justify-center w-12 h-12 rounded-full transition-all duration-200"
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.96 }}
        aria-label="Notifications"
        onClick={handleOpen}
        type="button"
      >
        <span className="sr-only">Open notifications</span>
        <span className="flex items-center justify-center">
          <NotificationIcon />
        </span>
        <NotificationBadge count={count} />
      </motion.button>
      <AnimatePresence>
        {open && (
          <NotificationDropdown onClose={handleClose} />
        )}
      </AnimatePresence>
    </div>
  );
}
